import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { TIMELINE_COPY } from '@sonar-software/sonar-ts-constants';
import { coreLib, TimelineChangeType, TimelineTableEntry } from '@sonar-software/sonar-core';

export type TimelineChangeRecordTypeFilter = Partial<Record<TimelineChangeType, boolean>>;

export type TimelineObjectFilter = Partial<Record<SonarObjectType, TimelineChangeRecordTypeFilter>>;

export function isRowExpandable(record: TimelineTableEntry): boolean {
	const { changeType } = record.change;

	return changeType === TimelineChangeType.Modified;
}

export function getChangeRecordClassName(changeType: TimelineChangeType, count?: number): string {
	return `statistic clickable ${count ? changeType : 'unmodified'}`;
}

export function getChangeTypeToChangeLabel(changeType: TimelineChangeType): string | undefined {
	switch (changeType) {
	case TimelineChangeType.Discovered:
		return TIMELINE_COPY.ADDED;
	case TimelineChangeType.Modified:
		return TIMELINE_COPY.MODIFIED;
	case TimelineChangeType.Vanished:
		return TIMELINE_COPY.DELETED;
	default:
		return undefined;
	}
}

export const TIMELINE_CHANGE_TYPE_ORDER = [
	TimelineChangeType.Discovered,
	TimelineChangeType.Modified,
	TimelineChangeType.Vanished
];

export const stringifyObjectFilter = (
	filters: TimelineObjectFilter
): string => Object.entries(filters).reduce((str, [ key, value ]) => {
	const binaryArray = TIMELINE_CHANGE_TYPE_ORDER.map((type) => (value?.[ type ] ? 1 : 0));
	const int = coreLib.binaryToInteger(binaryArray.join(''));
	const separator = str ? '|' : '';

	return `${str}${separator}${key}~${int}`;
}, '');

export const parseObjectFilter = (value: string): TimelineObjectFilter => (value ?
	value.split('|').reduce((filters, filterString) => {
		if (!filterString) {
			return filters;
		}

		const [ objectType, int ] = filterString.split('~');
		const binaryArray = Array.from(
			coreLib.integerToBinary(Number(int), 3),
			Number
		);

		return {
			...filters,
			[ objectType ]: TIMELINE_CHANGE_TYPE_ORDER.reduce((changes, type, index) => ({
				...changes,
				[ type ]: Boolean(binaryArray[ index ])
			}), {})
		};
	}, {}) :
	{}
);
